import hyphenCase from 'utils/hyphen-case';
import { DEFAULT_THEME, Theme, ThemeName, themes } from './index';

type MappedTheme = {
  [key: string]: string | null;
};

function mapTheme(variables: Theme): MappedTheme {
  return Object.keys(variables).reduce<{ [key: string]: string }>(
    (theme, key) => {

      theme[`--${hyphenCase(key)}`] = variables[key as keyof Theme];
      return theme;
    },
    {},
  );
}

export const applyTheme = (themeName: ThemeName): void => {
  const theme = mapTheme(themes[themeName]);
  if (!theme) return;

  const root = document.documentElement;

  Object.keys(theme).forEach(property => {
    root.style.setProperty(property, theme[property] as string);
  });
};

export function applyDefaultTheme() {
  applyTheme(DEFAULT_THEME);
}
